export default __webpack_public_path__ + "static/media/corruptedFile.5d5fdd6b.svg";